
<article *ngIf="(currencies$ | async) as curr">
<!-- <div *ngFor="let cur of curr">
         {{cur.currency}}: {{cur.value | number:'1.3-3'}} TL
    </div> -->
<!-- {{curr | json}} -->
<ul>
    <li>EURO €: {{curr.EUR.tlValue | number:'1.3-3'}} TL </li>
    <li>USD $: {{curr.USD.tlValue | number:'1.3-3'}} TL </li>
    <li>GBP £: {{curr.GBP.tlValue | number:'1.3-3'}} TL </li>
</ul>
</article>

